import { Component, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RolParametroAutonomia } from '../shared/rol-parametro-autonomia.model';
import { FabButtonGroupComponent } from 'src/app/shared/fabbuttongroup/fabbuttongroup.component';
import { ACTIONS, EVENTO, ICONS, LoaderService, NotificationService, TOOLTIPS } from 'src/app/shared/session';
import { RolParametroAutonomiaService } from '../shared/rol-parametro-autonomia.service';

@Component({
  selector: 'app-rol-parametro-autonomia-save',
  templateUrl: './rol-parametro-autonomia-save.component.html',
})
export class RolParametroAutonomiaSaveComponent implements OnChanges {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() data: any;
  @Input() titlePage: string;

  formGroupRolParametroAutonomia: FormGroup;
  msgErrorGuardar: string;
  obligatorioMsg: string;
  rolParametroAutonomia: RolParametroAutonomia;
  buttonGroup: any;
  parametro: string;
  @ViewChild(FabButtonGroupComponent) fabButtonGroupComponent: FabButtonGroupComponent;

  constructor(
    public fb: FormBuilder,
    private loaderService: LoaderService,
    private rolParametroAutonomiaService: RolParametroAutonomiaService,
    private notificationService: NotificationService
  ) { }

  ngOnChanges() {
    this.initData();
  }

  async initData() {
    this.msgErrorGuardar = 'Error al guardar rol parametro autonomia';
    this.obligatorioMsg = 'Campo Obligatorio';
    this.buttonGroup = [
      { tooltip: TOOLTIPS.save, icon: ICONS.save, action: ACTIONS.save }
    ];
    this.rolParametroAutonomia = new RolParametroAutonomia();
    this.parametro = this.data.parametro;
    this.setValuesFormBuilder();
    if (this.data != null && this.data.idRol != null && this.data.idParametroAutonomia != null) {
      this.rolParametroAutonomia = await this.rolParametroAutonomiaService.obtenerRolParametroAutonomia(this.data.idRol, this.data.idParametroAutonomia).toPromise();
      this.setValuesFormBuilder();
    }
  }

  setValuesFormBuilder() {
    this.formGroupRolParametroAutonomia = this.fb.group({
      valorMin: [this.rolParametroAutonomia.valorMin, Validators.compose([
        Validators.pattern("^([0-9]+(\\.[0-9]{1,2})?)$"),
        Validators.min(0),
        Validators.required,
      ]),],
      valorMax: [this.rolParametroAutonomia.valorMax, Validators.compose([
        Validators.pattern("^([0-9]+(\\.[0-9]{1,2})?)$"),
        Validators.min(0),
        Validators.required,
      ]),],
    });
  }

  formGroupRolParametroAutonomiaSubmit(event) {
    if (this.formGroupRolParametroAutonomia.invalid)
      return;
    let valorMin = Number.parseFloat(event.value.valorMin);
    let valorMax = Number.parseFloat(event.value.valorMax);
    const minEsValido = !isNaN(valorMin);
    const maxEsValido = !isNaN(valorMax);
    if (minEsValido && maxEsValido && valorMin > valorMax) {
      this.notificationService.warning(
        'El valor mínimo debe ser menor o igual al valor máximo'
      );
      return;
    }
    if (this.fabButtonGroupComponent.disabled) return;
    this.fabButtonGroupComponent.disabled = true;
    this.rolParametroAutonomia.idRol = this.data.idRol;
    this.rolParametroAutonomia.idParametroAutonomia = this.data.idParametroAutonomia;
    this.rolParametroAutonomia.valorMin = valorMin;
    this.rolParametroAutonomia.valorMax = valorMax;
    this.guardarRolParametroAutonomia();
  }

  async guardarRolParametroAutonomia() {
    this.loaderService.show();
    try {
      await this.rolParametroAutonomiaService.guardarRolParametroAutonomia(this.rolParametroAutonomia).toPromise();
      this.notificationService.successful("Datos guardados con éxito");
      this.changeEvent({ evento: EVENTO.asignarAutonomia, data: this.data });
    } catch (error) {
      this.notificationService.error(this.msgErrorGuardar);
      throw error;
    } finally {
      this.loaderService.hide();
      this.fabButtonGroupComponent.disabled = false;
    }
  }

  changeEvent(event) {
    this.onChangeEvent.emit(event);
  }
}
